var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6999 8.79999V16.8C3.6999 17.5 4.2999 18.1 4.9999 18.1H19.2999C19.9999 18.1 20.5999 17.5 20.5999 16.8V8.79999M23.8999 2.89999V21.4C23.8999 22.8 22.7999 23.9 21.3999 23.9H2.8999C1.4999 23.9 0.399902 22.8 0.399902 21.4V2.89999C0.399902 1.49999 1.4999 0.399994 2.8999 0.399994H21.3999C22.7999 0.399994 23.8999 1.49999 23.8999 2.89999ZM12.1999 14.6C12.9999 14.6 14.0999 13.6 14.5999 13.2C19.3999 9.69999 19.2999 9.69999 20.5999 8.69999V7.49999C20.5999 6.79999 19.9999 6.19999 19.2999 6.19999H4.9999C4.2999 6.19999 3.6999 6.79999 3.6999 7.49999V8.79999C4.9999 9.79999 4.8999 9.79999 9.6999 13.3C10.2999 13.7 11.3999 14.6 12.1999 14.6Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3,
    height: 24.3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.55a03b4c3cf7c7a3e04c4797d48513ee.svg";
export { ForwardRef as ReactComponent };